// Instructional language config. English is the source; the other five are
// overlays on lessons + walkthroughs only (exam content stays English).
// Ordering here is what the switcher shows top-to-bottom.
export const LANGS = [
  { code: 'en', label: 'English',      native: 'English',   dir: 'ltr' },
  { code: 'zh', label: 'Chinese',      native: '中文',       dir: 'ltr' },
  { code: 'ko', label: 'Korean',       native: '한국어',      dir: 'ltr' },
  { code: 'es', label: 'Spanish',      native: 'Español',    dir: 'ltr' },
  { code: 'ar', label: 'Arabic',       native: 'العربية',    dir: 'rtl' },
  { code: 'fa', label: 'Farsi',        native: 'فارسی',      dir: 'rtl' },
];

export const LANG_BY_CODE = Object.fromEntries(LANGS.map((l) => [l.code, l]));
export const SUPPORTED_LANG_CODES = LANGS.map((l) => l.code);

export const langDir = (code) => (LANG_BY_CODE[code]?.dir || 'ltr');
export const langLabel = (code) => (LANG_BY_CODE[code]?.native || 'English');
